import React, {useEffect, useState} from "react";
import { connect } from "react-redux";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

import LangTab from "../../../components/tabs/langTab";
import { FL_TITLE} from "../../../components/i18n/formLabels";
import { PH_TITLE} from "../../../components/i18n/placeHolders";
import { searchActiveLangs } from "../../../redux/actions/langActions";
import { setLangs } from "../../../redux/actions/generalActions/formActions";


const AybAttributeLangs = props => {
    const { disableInputs, domainObject } = props.formProps
    const langItemChilds = domainObject?.langs || []

    const [langChilds, setLangChilds] = useState([])

    useEffect( () => {
        if(props.activeLangs.length > 0)
            return

        props.searchActiveLangs();
    },[] )

    useEffect(() => {
        setDataDefault()
    },[ props.activeLangs ])

    useEffect( () => {
        if(domainObject != null)
            return

        setDataDefault()
    },[ domainObject ])

    const setDataDefault = () => {
        const items = props.activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name },
            title: '',
        }) )

        setLangChilds(items);
    }

    const getLangChilds = () => {
        // langItemChilds : Los langs del item registrado
        // langChilds : Las opciones de lang generales
        return (langItemChilds.length > 0 ? langItemChilds : (langChilds.length > 0 ? langChilds : []));
    }

    const onInputChange = (e, lang) => {
        // Se busca el indice del idioma que se esta editando
        const langIndex = langItemChilds.length > 0 ? langItemChilds.findIndex(n => n.lang.id === lang.id) : langChilds.findIndex(n => n.lang.id === lang.id);

        if(langIndex === -1)
            return;
        // Se genera un nuevo arreglo para poder editar
        const langs = langItemChilds.length > 0 ? langItemChilds.slice() : langChilds.slice();

        langs[langIndex] = { ...langs[langIndex], [ e.target.name ]: e.target.value };
        props.setLangs(langs);
        setLangChilds(langs);
    }

    const getFormulary = (child, index, disableInputs) => <>
        <Row>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{FL_TITLE}</Label>
                    <Input
                        type="text"
                        name="title"
                        placeholder={PH_TITLE}
                        value= { child.title }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return(<Row>
        <Col>
            <LangTab
                key={"LangId"}
                langChilds={ langChilds }
                getLangChilds={ getLangChilds }
                getFormulary={ getFormulary }
                disableInputs={ disableInputs }
            />
        </Col>
    </Row>)
}

const mapStateToPropsLang = state => ({
    activeLangs : state.langs,
    formProps : state.formProps,
})

const mapActionsToPropsLang = ({
    searchActiveLangs,
    setLangs,
})

export default connect(mapStateToPropsLang, mapActionsToPropsLang)(AybAttributeLangs)